import { useQuery } from "@tanstack/react-query";
import { getMyPurchases } from "@/services/core-api-adapter";

export default function useGetMyPurchases(
  skipCount?: number,
  listLength?: number
) {
  const { data, error, isError, isPending, isLoading } = useQuery({
    queryKey: ["getPurchases", skipCount, listLength],
    queryFn: async ({ signal }) => {
      const responseData = await getMyPurchases(skipCount, listLength, {
        signal,
      });
      return responseData;
    },
    staleTime: 30 * 1000,
    gcTime: 3 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  return {
    purchases: data?.purchases,
    skipCount: data?.skipCount,
    listLength: data?.listLength,
    purchasesCount: data?.total,
    purchasesFetchError: error || isError,
    isPurchasesLoading: isPending || isLoading,
  };
}
